import { RATING_MAX, type RatingStar } from '../constants/icons'

export function ratingStars(rating: number, max: number = RATING_MAX): RatingStar[] {
  const filledCount = Math.round(Math.min(Math.max(rating, 0), max))
  return Array.from({ length: max }, (_, index) => ({
    id: index,
    filled: index < filledCount,
  }))
}
